import React, { useMemo, useState } from 'react';

import LoginForm from '@/features/login/components/LoginForm';
import { selectAuthError, selectIsSignInLoading } from '@/features/login/selectors';
import { signInWithCredentials } from '@/features/login/slice';
import { selectHasSessionToken } from '@/features/user/selectors';
import { useAppDispatch } from '@/hooks';
import { withAuthLayout } from '@/layouts/Auth';

import { Spinner } from '@bypasslane/clover--web-lib-sprout-spinner';
import { is } from 'ramda';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { selectSuccess as selectPasswordChangeSuccess } from '../../passwordManagement/slice';

const SessionLoadingSpinner = withAuthLayout(() => (
  <div className="text-center py-5">
    <div className="flex justify-center items-center mb-4">
      <Spinner ariaLabel="loading" spinnerSize="large" spinnerVariant="greenSpinner" />
    </div>
    <p className="mt-4 text-lg font-medium text-gray-700">Loading session...</p>
  </div>
));

const LoginFormContainer = () => {
  const dispatch = useAppDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const [loginResponse, setLoginResponse] = useState();
  const [loginError, setLoginError] = useState();

  const authError = useSelector(selectAuthError);
  const isSignInLoading = useSelector(selectIsSignInLoading);
  const hasSessionToken = useSelector(selectHasSessionToken);
  const passwordChangeSuccess = useSelector(selectPasswordChangeSuccess);

  const error = useMemo(() => {
    if (is(Object, authError)) {
      return authError.message;
    }
    return authError || loginResponse?.error || loginError?.message;
  }, [authError, loginResponse, loginError]);

  const onSubmit = (data) => {
    dispatch(signInWithCredentials(data))
      .unwrap()
      .then((loginResponse) => setLoginResponse(loginResponse))
      .catch((loginError) => setLoginError(loginError));
  };

  const loginFormProps = {
    register,
    handleSubmit,
    isSignInLoading,
    onSubmit,
    error,
    passwordChangeSuccess,
    errors
  };

  if (hasSessionToken) {
    return <SessionLoadingSpinner />;
  }

  return <LoginForm {...loginFormProps} />;
};

export default withAuthLayout(LoginFormContainer, {
  enableProfiler: true,
  enableErrorBoundary: true
});
